import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TopRank from "./components/TopRank";
import Featured from "./components/Featured";
import Specials from "./components/Specials";
import Brief from "./components/Brief";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TopRank />
        <Featured />
        <Specials />
        <Brief />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}